import { apiClient } from "./client";

export type ExpiringDocumentsReport = {
  scanned: number;
  notified: number;
  skipped_recently_notified: number;
  skipped_no_user: number;
  horizon_days: number;
};

export async function runExpiringDocumentsJob(
  days = 30,
): Promise<ExpiringDocumentsReport> {
  const { data } = await apiClient.post<ExpiringDocumentsReport>(
    "/api/v1/admin/jobs/expiring-documents/run",
    null,
    { params: { days } },
  );
  return data;
}
